import React from 'react';

import { Message, Link, Spacer } from 'src/core/components';

import messages from './messages';

const CONFIGURATOR_LINK = 'https://rnaidesigner.thermofisher.com/rnaiexpress/inVivoService.jsp';
const CUSTOM_RNA_CONFIGURATOR_LINK = `${window?.location?.origin || 'https://www.thermofisher.com'}/order/custom-genomic-products/tools/sirna/`;

const HPLCPurificationComponent = () => (
  <>
    <div>
      <span>
        <Message message={messages.chooseHPLCPurification} />
      </span>
      <span>
        {' '}
      </span>
      <Link href={CONFIGURATOR_LINK}>
        <Message message={messages.configuratorLink} />
      </Link>
      .
    </div>
    <Spacer top={14} bottom={14}>
      <Message message={{
        ...messages.customsiRNALink,
        values: {
          geneAssistUrl: (
            <Link href={CUSTOM_RNA_CONFIGURATOR_LINK}>
              <Message message={messages.geneAssistUrl} />
            </Link>
          )
        }
      }}
      />
    </Spacer>
  </>
);

export default HPLCPurificationComponent;
